import { useParams } from 'react-router';

import { Step } from '../app/entities/step';

export const useCurrentStep = () => {
  const { stepId } = useParams() as { stepId: string };

  return Step.getOne(stepId);
};
